<template>
  <span class="proa-badge">{{ value }}</span>
</template>

<script>
export default {
  name: 'ProaBadge',
  props: {
    value: [String, Number]
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.proa-badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 26px;
  min-height: 16px;
  background-color: $background-color;
  color: $secondary-color;
  font-size: 9px;
  font-weight: 600;
  padding-right: .6em;
  padding-left: .6em;
  border-radius: 10rem;
}
</style>
